<template>
  <div class="d-flex justify-content-between pb-1 gap-2 w-25" style="border: 2px solid black; border-radius: 5px 5px 0 0; padding: 5px; background: black">
    <n-input :placeholder="inputPlaceholder" v-model:value="searchBar" @keyup.enter="this.searchSupplies">
      <template #suffix>
        <i class="icon-remove-circle input-icon" @click="this.cleanSearch"></i>
      </template>
    </n-input>
    <n-button secondary type="info" @click="this.searchSupplies" style="background: white">Buscar</n-button>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import supplyStore from "../../store/supply";

export default {
  data() {
    return {
      searchbar: "",
    };
  },
  props: {
    inputPlaceholder: String,
    supplyType: String,
  },
  methods: {
    ...mapActions(supplyStore, ["getSupplies"]),
    async searchSupplies() {
      let supplies = await this.getSupplies(this.supplyType, this.searchBar);
      this.$emit("suppliesSearched", supplies);
    },
    async cleanSearch() {
      this.searchBar = "";
      let supplies = await this.getSupplies(this.supplyType);
      this.$emit("searchBarCleaned", supplies);
    },
  },
};
</script>
